import wx from "weixin-js-sdk"; // 微信sdk依赖
import { get } from "@/http/request.js";

function getJSSDK(dataForWeixin) {
  let params = {
    url: window.location.href.split("#")[0],
  };

  get("plus-cloud-manage-app/wxShare/getSignature", params).then((res) => {
    console.log("签名", res.data);
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.data.appId, // 必填，公众号的唯一标识
      timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.noncestr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名
      jsApiList: [
        "onMenuShareAppMessage",
        "onMenuShareTimeline",
        "updateAppMessageShareData",
        "updateTimelineShareData",
      ], // 必填，需要使用的JS接口列表
    });

    wx.error(function (res) {
      console.log("wx.error", res);
    });

    wx.ready(function () {
      let { title, desc, linkurl, img, operateId, operateType } = dataForWeixin;
      let shareData = {
        title: title,
        desc: desc, //这里请特别注意是要去除html
        link: linkurl,
        imgUrl: img,
        success: function (res) {
          console.log("分享成功！", res);
          alert("分享成功！");
          if ([1, 2, 4, 5].includes(operateType)) {
            // console.log("类型", operateType, operateId, getBrowserCookie("gzbn_cookie_id"));
            get("plus-cloud-interact-app/clickAndShare/shareRecord", {
              operateId: operateId,
              operateType: operateType,
              deviceId: getBrowserCookie("gzbn_cookie_id"),
              cookieId: getBrowserCookie("gzbn_cookie_id"),
            })
              .then((res) => {
                console.log("shareRecord记录成功", res);
              })
              .catch();
          }
        },
        fail: function (res) {
          console.log("分享失败！");
          // alert("fail");
        },
      };
      // 兼容新老版本接口
      if (wx.onMenuShareAppMessage) {
        console.log("aaa");
        wx.onMenuShareAppMessage(shareData); // 1.0 分享到朋友(即将废弃)
        wx.onMenuShareTimeline(shareData); // 1.0 分享到朋友圈(即将废弃)
      } else {
        console.log("bbb");
        wx.updateAppMessageShareData(shareData); // 1.4 分享到朋友
        wx.updateTimelineShareData(shareData); // 1.4 分享到朋友圈
      }
    });
  });
}

function getBrowserCookie(name) {
  var cookieArr = document.cookie.split("; ");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    if (cookiePair[0] === name) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

export default {
  // 获取JSSDK
  getJSSDK,
};
